// Import SCSS (processed by Vite)
import "../scss/app.scss";
var $ = jQuery;
import "./lib/menu";
import "./lib/general";
import "./lib/slick";
import "./lib/event-post-filter";
import "./lib/jquery.selectbox";
import "./lib/jquery.flexslider";
import "./lib/sticky-nav-buttons";
import "./lib/booking-modal";
window.$ = $;